import React from 'react';
import { ChevronLeft } from 'lucide-react';
import { useNavigation } from '../../context/NavigationContext';
interface HeaderProps {
  title?: string;
  showBack?: boolean;
  rightElement?: React.ReactNode;
  transparent?: boolean;
}
export function Header({
  title,
  showBack = true,
  rightElement,
  transparent = false
}: HeaderProps) {
  const {
    goBack
  } = useNavigation();
  return <div className={`flex items-center justify-between px-4 py-3 sticky top-0 z-40 ${transparent ? 'bg-transparent absolute w-full' : 'bg-surface border-b border-gray-100'}`} data-id="element-108">
      <div className="flex items-center w-1/3" data-id="element-109">
        {showBack && <button onClick={goBack} className="p-2 -ml-2 rounded-full hover:bg-gray-100 transition-colors" aria-label="Go back" data-id="element-110">
            <ChevronLeft className="w-6 h-6 text-gray-800" data-id="element-111" />
          </button>}
      </div>

      <div className="flex-1 text-center" data-id="element-112">
        {title && <h1 className="text-lg font-semibold text-gray-900 truncate" data-id="element-113">
            {title}
          </h1>}
      </div>

      <div className="flex items-center justify-end w-1/3" data-id="element-114">{rightElement}</div>
    </div>;
}